import { AccessTimeOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { useState } from 'react';

import { graphql, type DocumentType } from '@/gql';

import { ReviewDateFileDialog } from '../../../../dialogs/ReviewDateFileDialog';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const REVIEW_DATE_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment reviewDateFileMenuItemFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof REVIEW_DATE_FILE_MENU_ITEM_FILE_FRAGMENT>;
  canEdit: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const ReviewDateFileMenuItem = ({
  file,
  canEdit,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const { workflow } = file;
  const { reviewDate } = workflow || {};

  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <MaybeUsableMenuItem
        isUsable={canEdit}
        isExpectedUsable={canLockRoot}
        unusableExplanation={unusableExplanation}
        onClick={() => {
          onClose();
          setDialogOpen(true);
        }}
      >
        <ListItemIcon>
          <AccessTimeOutlined />
        </ListItemIcon>
        <ListItemText
          primary={`${
            reviewDate ? 'Change or clear the' : 'Set a'
          } review date...`}
        />
      </MaybeUsableMenuItem>
      <ReviewDateFileDialog
        file={file}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
